import React from 'react';
import ReactDOM from 'react-dom';

export function WrapReactComponent( _component: any ){
    const wrapped = function(props, root: HTMLElement, appendWrapper: boolean) {
        const component = _component;
        let container = root;
        if( appendWrapper ){
            const wrapper = document.createElement('div');
            root.appendChild(wrapper);
            container = wrapper;
        }

        const comp = React.createElement(component, props);

        const reactComponent = ReactDOM.render(comp, container);
        return reactComponent;
    }

    return wrapped;
}


// WEBPACK FOOTER //
// src/components/WrapReactComponent.jsx